import cn from "classnames";
import { useEffect, useLayoutEffect, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { NUM_GUESSES } from "../consts";
import { allWordsGuessed } from "../funcs";
import {
  loadGameFromLocalStorage,
  loadSettingsFromLocalStorage,
  loadStatsFromLocalStorage,
  loadPracticeFromLocalStorage,
  saveGameToLocalStorage,
  saveSettingsToLocalStorage,
  saveStatsToLocalStorage,
  savePracticeToLocalStorage,
} from "../serialize";
import { addHistory, useSelector } from "../store";
import GameBoard from "./GameBoard";
import Header from "./Header";
import Keyboard from "./Keyboard";
import Result from "./Result";
import { Settings } from "./Settings";
import Stats from "./Stats";

export default function Game({ type = 'sedecordle' }) {
  const dispatch = useDispatch();

  const [searchParams] = useSearchParams();
  const length: number = Number(searchParams.get('length') || 5);
  const mode: string = searchParams.get('mode') || '';
  const isPractice = window.location.pathname === `/${type}/practice` || mode === 'free';
  // const gameType: any = localStorage.getItem('mode-type')

  //  const isDaily = gameType.split(',')[0];
  //  const gameMode = gameType.split(',')[1];

  // console.log(mode, length, isPractice, isDaily, gameMode)

  // useEffect(() => {

  //   if (length === 5) {
  //     document.querySelector('title')!.innerText = isDaily === 'daily' ? `Daily ${gameMode}` : `Practice ${gameMode}` 
  //     switch(gameMode) {
  //       case 'sedec-order': 
  //       document.querySelector('meta[name="description"]')!.setAttribute('content', 'Sedecorder is similar to the original Sedecordle game. Except one unsolved word at a time, once solved the next board is unlocked.');
  //         break;
  //       case 'savior':
  //         document.querySelector('meta[name="description"]')!.setAttribute('content', 'Just like the original sedecordle game but the first four words are chosen for you.');
  //         break;        
  //       default:
  //         document.querySelector('meta[name="description"]')!.setAttribute('content', "It's like wordle, but you solve 16 wordles at once! You get 21 guesses to solve all the puzzles. A unique sedecordle every day and unlimited free puzzles!");
  //     }
  //   }
  //   const gameLengthInWords = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten', 'eleven']
  //   function numberToWords(num: any) {
  //     return gameLengthInWords[num];
  //   }
  //   if (length !== 5) {
  //     document.querySelector('title')!.innerText = isDaily === 'daily' ? `Daily ${length} Letter ${gameMode}` : `Practice ${length} Letter ${gameMode}` 
  //     switch(gameMode) {
  //       case 'sedec-order': 
  //       document.querySelector('meta[name="description"]')!.setAttribute('content', `Just like the original ${isDaily} sedec-order but with ${numberToWords(length)} letter words!`);
  //         break;
  //       case 'savior':
  //         document.querySelector('meta[name="description"]')!.setAttribute('content', `Just like the original ${isDaily} savior but with ${numberToWords(length)} letter words!`);
  //         break;        
  //       default:
  //         document.querySelector('meta[name="description"]')!.setAttribute('content', `Just like the original ${isDaily} sedecordle but with ${numberToWords(length)} letter words!`);
  //     }
  //   } 
  // }, [isDaily, gameMode, length])

  useLayoutEffect(() => {
    isPractice ? loadPracticeFromLocalStorage(dispatch, length, type) :
    loadGameFromLocalStorage(dispatch, length, type);
    loadSettingsFromLocalStorage(dispatch, type);
    if (!isPractice) loadStatsFromLocalStorage(dispatch, type); 
    
  }, [dispatch, length, type, isPractice]);

  const game = useSelector((s) => s.game);
  useEffect(() => {
    if (!isPractice) {
      saveGameToLocalStorage(game, length, type);
    }
    if (isPractice) {
      savePracticeToLocalStorage(game, length, type);
    }
  }, [game, length, type, isPractice]);
  const settings = useSelector((s) => s.settings);
  useEffect(() => {
    saveSettingsToLocalStorage(settings, type);
  }, [settings, type]);
  const stats = useSelector((s) => s.stats);
  useEffect(() => {
    saveStatsToLocalStorage(stats, type);
  }, [stats, type]);

  const targets = useSelector((s) => s.game.targets);
  const guesses = useSelector((s) => s.game.guesses);

  const guessesUsedUp = guesses.length === NUM_GUESSES;
  const gameWin = useMemo(
    () => allWordsGuessed(guesses, targets),
    [guesses, targets]
  );
  const gameOver = guessesUsedUp || gameWin;
  const gameLose = guessesUsedUp && !gameWin;
  const colorBlindMode = useSelector((s) => s.settings.colorBlindMode);
  const wideMode = useSelector((s) => s.settings.wideMode);
  const hideCompletedBoards = useSelector(
    (s) => s.settings.hideCompletedBoards
  );
  const animateHiding = useSelector((s) => s.settings.animateHiding);

  // Add to stat history if game over and not already in history
  useEffect(() => {
    if (
      gameOver &&
      !game.practice &&
      !stats.history.find((v) => v.id === game.id)
    ) {
      let guesses;
      if (gameWin) {
        guesses = game.guesses.length;
      } else {
        guesses = null;
      }
      const time = game.endTime - game.startTime;
      if (!isPractice) dispatch(addHistory({ id: game.id, guesses, time }));
    }
  }, [
    dispatch,
    game.endTime,
    game.startTime,
    game.guesses.length,
    game.id,
    game.practice,
    gameOver,
    gameWin,
    stats.history,
    type,
    isPractice
  ]);


  return (
    <>
      <div
        className={cn(
          "game",
          gameWin && "win",
          gameLose && "lose",
          colorBlindMode && "color-blind",
          wideMode && "wide",
          hideCompletedBoards &&
            !(gameWin || gameLose) &&
            "hide-completed-boards",
          animateHiding && "animate-hiding"
        )}
      >
        <Header type={type} />
        <GameBoard type={type} />
        <Keyboard hidden={gameOver} />
        <Result hidden={!gameOver} />
      </div>
      <Settings />
      <Stats />
    </>
  );
}



